import SensorTypeDto from 'app/admin/sensorType/dto/SensorTypeDto';
import IdentifiableDto from 'modules/base/dto/IdentifiableDto';
import NamedDto from 'modules/base/dto/NamedDto';

export default class EdaItemDto extends IdentifiableDto {
	constructor() {
		super();
		/** @type {NamedDto} */
		this.edaType = null;
		/** @type {SensorTypeDto} */
		this.sensorType = null;
		/** @type {Date} */
		this.created = null;
		/** @type {Date} */
		this.updated = null;
		/** @type {string} */
		this.file = null;
	}

	/**
	 * @typedef {Object} _EdaItemDtoProps
	 * @property {NamedDto} edaType
	 * @property {SensorTypeDto} sensorType
	 * @property {Date} created
	 * @property {Date} updated
	 * @property {string} file
	 *
	 * @typedef {import("modules/base/dto/IdentifiableDto").IdentifiableDtoProps & _EdaItemDtoProps} EdaItemDtoProps
	 */
	/**
	 *
	 * @param {EdaItemDtoProps} props
	 * @returns {EdaItemDto}
	 */
	setup(props) {
		super.setup(props);
		this.edaType = props.edaType !== null ? new NamedDto().setup(props.edaType) : null;
		this.sensorType = props.sensorType !== null ? new SensorTypeDto().setup(props.sensorType) : null;
		this.created = props.created !== null ? new Date(props.created) : null;
		this.updated = props.updated !== null ? new Date(props.updated) : null;
		this.file = props.file;
		return this;
	}
}
